(function () {
  'use strict';

  angular.module('selectbox').controller('selectboxCtrl', selectboxCtrl);

  selectboxCtrl.$inject = [];

  function selectboxCtrl() {
    var vm = this;
  }
})();
